import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var useErrorHandling = function (_a) {
    var errorPlans = _a.errorPlans, errorPaymentMode = _a.errorPaymentMode, errorAllQuote = _a.errorAllQuote, errorGetCatalogPlanReference = _a.errorGetCatalogPlanReference, errorTravelPremiums = _a.errorTravelPremiums, errorComplete = _a.errorComplete, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorGetCatalogPlanReference) {
            showErrorToast(errorGetCatalogPlanReference, setSeeToast, t);
        }
    }, [errorGetCatalogPlanReference]);
    useEffect(function () {
        if (errorTravelPremiums) {
            showErrorToast(errorTravelPremiums, setSeeToast, t);
        }
    }, [errorTravelPremiums]);
    useEffect(function () {
        if (errorComplete) {
            showErrorToast(errorComplete, setSeeToast, t);
        }
    }, [errorComplete]);
};
